import React from "react";
import { BsFacebook, BsInstagram } from "react-icons/bs";

const Footer = () => {
  return (
    <div className=" h-32 bg-black  w-full text-white flex flex-col justify-center items-center gap-4">
      <span>Холбоо барих</span>
      <span>89257078</span>
      <div className="flex gap-2 text-2xl">
        <a href={'https://www.facebook.com/profile.php?id=100092189683329'}>
          <BsFacebook />
        </a>
        <BsInstagram />
      </div>
    </div>
  );
};

export default Footer;
